import { render, staticRenderFns } from "./AppButtonVerificationPending.vue?vue&type=template&id=73a24a0e&scoped=true&"
import script from "./AppButtonVerificationPending.vue?vue&type=script&lang=js&"
export * from "./AppButtonVerificationPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a24a0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a24a0e')) {
      api.createRecord('73a24a0e', component.options)
    } else {
      api.reload('73a24a0e', component.options)
    }
    module.hot.accept("./AppButtonVerificationPending.vue?vue&type=template&id=73a24a0e&scoped=true&", function () {
      api.rerender('73a24a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppButtonVerificationPending.vue"
export default component.exports